import { sortBy } from 'lodash';
import WidgetModel from '@mm/state/model/WidgetModel';
import { LAST_WIDGET_SORT_ORDER } from './constants';

// Push down all of the widgets below the focused widget so that we can assign to it the current sort order
export const arrangeWidgetSortOrder = (
  newWidgetSortOrder: number,
  widgets: WidgetModel[],
) => {
  const sortedWidgets = sortBy<WidgetModel>(widgets, ['sortOrder']);

  return sortedWidgets.map(widget => {
    if (
      widget.sortOrder >= newWidgetSortOrder &&
      widget.sortOrder !== LAST_WIDGET_SORT_ORDER
    ) {
      return {
        ...widget,
        sortOrder: widget.sortOrder + 1,
      };
    }

    return widget;
  });
};
